import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-sort-header',
  imports: [],
  templateUrl: './sort-header.html',
  styleUrl: './sort-header.scss',
})
export class SortHeader {
  columnName = input<string>();
  columnKey = input<string>();
  sortBy = input<string>();
  sortOrder = input<string>();
  toggleSort = output<string>();

  handleToggleSort(columnName: string) {
    this.toggleSort.emit(columnName);
  }
}